export default function SVG_Text_Tspan() {
  return (
    <div>
      <h1>SVG_Text_Tspan Component</h1>
    </div>
  );
}
